var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.css)},[_vm._t("default",function(){return [_vm._v("This is a bubble element")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }